import {
  Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output,
  Renderer2
} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {CPATTERN, TenantType} from '../../../shared/helpers/app.constants';
import {CompaniesService} from './companies.service';
import {ToasterService} from '../../../shared/services/toaster.service';
import {orderBy, cloneDeep, isEqual} from 'lodash';
import {LoadingOverlayService} from '../../../shared/services/loading-overlay.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-companies-form',
  templateUrl: './companies-form.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesFormComponent implements OnInit, OnDestroy {

  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;
IsAgePolicyApply:boolean=false
  dataWells: any;
  dataEquipment: any;
  dataSpread: any;

  param: any;
  companyId: number;
  
  // Type
  typeList: any[] = [
    {
      value: 0,
      text: 'Operator',
    },
    {
      value: 1,
      text: 'Services',
    }];
  selectedTypeList: any[] = [
    {
      value: 0,
      text: 'Operator',
    }
  ];
  // Policy
  PolicyList: any[] = [
    {
      value: "Age",
      text: 'Age',
    },
    {
      value:"Count",
      text: 'Count',
    }];
    SelectedPolicyList: any[] = [
      {
        value:"Count",
        text: 'Count',
      }
  ];

  form: FormGroup;
  name: AbstractControl;
  maxUser: AbstractControl;
  maxHistoricalWell: AbstractControl;
  type: AbstractControl;
  maxFracSpread: AbstractControl;
  maxEquipment: AbstractControl;
  isAllWell: AbstractControl;
  canHaveDataFiles: AbstractControl;
months:AbstractControl;
policies:AbstractControl
  originFormValue: any;
  originDataWells: any;
  originDataSpread: any;
  originDataEquipment: any;
  allWellData: any;
  
  @Input()
  set model(data: any) {
    if (data) {
      this.param = data;
      this.companyId = this.param.id;
      this.name.setValue(this.param.name);
      this.maxUser.setValue(this.param.maxUser);
      this.maxHistoricalWell.setValue(this.param.maxHistoricalWell);
      this.type.setValue(this.param.type);
      this.maxFracSpread.setValue(this.param.maxFracSpread);
      this.maxEquipment.setValue(this.param.maxEquipment);
      this.isAllWell.setValue(this.param.isAllWell);
      this.canHaveDataFiles.setValue(this.param.canHaveDataFiles);
      this.onChange(this.param.type);
      this.getCompanyItem(this.companyId,'');
      this.months.setValue(this.param.months?this.param.months:1);
      let policyValue=this.param.policies?this.param.policies:"Count"
      this.policies.setValue(policyValue);
      this.selectedTypeList = [{
          value: this.param.type,
          text: this.param.typeName
        }];
      this.SelectedPolicyList = [{
          value: policyValue,
          text: policyValue
        }];

      if (this.form && this.form.value) {
        this.originFormValue = cloneDeep(this.form.value);
      }
    }
  }

  @Output() success: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  constructor(private companiesService: CompaniesService,
              private toasterService: ToasterService,
              private loadingOverlayService: LoadingOverlayService,
              private renderer: Renderer2,private toastr: ToastrService) {
    this.createForm();
    const container =  document.querySelector('.main-content');
    this.renderer.setStyle(container, 'padding-bottom', '78px');
  }

  createForm() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(this.cvalidate.COMPANY_NAME)])),
      maxUser: new FormControl(0, Validators.compose([Validators.required, Validators.min(0), Validators.max(1000)])),
      maxHistoricalWell: new FormControl(0, Validators.compose([Validators.required, Validators.min(0), Validators.max(1000)])),
      type: new FormControl(0, [Validators.required]),
      maxFracSpread: new FormControl(0),
      maxEquipment: new FormControl(0),
      isAllWell: new FormControl(false),
      canHaveDataFiles: new FormControl(false),
      months:new FormControl(1,[Validators.min(1), Validators.max(60),Validators.required]),
      policies:new FormControl("Count")
    });
    this.name = this.form.controls['name'];
    this.maxUser = this.form.controls['maxUser'];
    this.maxHistoricalWell = this.form.controls['maxHistoricalWell'];
    this.type = this.form.controls['type'];
    this.maxFracSpread = this.form.controls['maxFracSpread'];
    this.maxEquipment = this.form.controls['maxEquipment'];
    this.isAllWell = this.form.controls['isAllWell'];
    this.canHaveDataFiles = this.form.controls['canHaveDataFiles'];
    this.months = this.form.controls['months'];
    this.policies = this.form.controls['policies'];
  }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    const container =  document.querySelector('.main-content');
    this.renderer.removeStyle(container, 'padding-bottom');
  }
  getWellWithCompanyId(id) {
  this.companiesService.getWellByCompanyId(id).subscribe(
      (res) => {
        this.allWellData=res;
      });
      
  }
   onSubmit(e: any,str) {
    if (this.form.valid) {
      if (this.isChangeOriginData()) {
        this.loading = true;
        this.submitted = true;
        const obj: any = this.form.value;
        obj.wellDtos = this.maxHistoricalWell.value ? (this.dataWells ? (!this.isAllWell.value ? this.dataWells : []) : []) : [];
        obj.fracSpreadDtos = this.maxFracSpread.value ? (this.dataSpread ? (this.param ? this.dataSpread : this.dataSpread.map(item => item.name)) : []) : [];
        obj.equipmentDtos = this.maxEquipment.value ? (this.dataEquipment ? (this.param ? this.dataEquipment : this.dataEquipment.map(item => item.name)) : []) : [];
        obj.maxFracSpread = this.maxFracSpread.value ? this.maxFracSpread.value : 0;
        obj.maxEquipment = this.maxEquipment.value ? this.maxEquipment.value : 0;
        if (this.type.value === 0) {
          obj.maxFracSpread = 0;
          obj.maxEquipment = 0;
          obj.fracSpreadDtos = [];
          obj.equipmentDtos = [];
        }
        if (this.isAllWell.value) {
          obj.maxHistoricalWell = 0;
        }
        if (!this.param) {
          if(str=='update'){
            this.loadingOverlayService.show();
          }
          this.companiesService.create(obj, () => {
            this.loading = false;
            this.submitted = false;
            if(str=='update'){
              this.loadingOverlayService.hide();
            }
          }).subscribe((res) => {
            this.success.emit();
          });
        } else {
          if(this.IsAgePolicyApply || obj.policies=='Count'){
            if(str=='update'){
              this.loadingOverlayService.show();
            }
            this.companiesService.update(this.param.id, obj, () => {
              this.loading = false;
              this.submitted = false;
             
            }).subscribe((res) => {
              if(str=='update' && this.policies.value!=='Age'){
             
                this.success.emit();
              
                this.loadingOverlayService.hide();
              }
              else{ 
                this.companiesService.UpdatePolicyInWell(this.companyId,this.months.value).subscribe(
                (res) => {  
                  this.getCompanyItem(this.companyId,str);
                });}
            }, (err) => {
              this.loadingOverlayService.hide()
            });
            
          }
          else{
            if(this.param.policies=='Count' && obj.policies=='Age'){
              Swal.fire({
                icon: 'warning',
                text: ` Apply policy button is not clicked. Current policy is Count. Do you want to apply policy`,
                showCancelButton: true,
                confirmButtonText: 'No, Continue with Count',
                cancelButtonText: "Yes, Apply Policy First",
              }).then((result) => {
                if (result.value) {
                obj.months=this.param.months;
                obj.policies=this.param.policies;
                obj.maxHistoricalWell=this.param.maxHistoricalWell=="All"?0:this.param.maxHistoricalWell;
                this.loadingOverlayService.show();
                this.companiesService.update(this.param.id, obj, () => {
                  this.loading = false;
                  this.submitted = false;
                  
                }).subscribe((res) => {
                  this.success.emit();
                  this.loadingOverlayService.hide();
                }, (err) => {
                  this.loadingOverlayService.hide()
                });
                }
                this.loading = false;
                this.submitted = false;
              });
            }else{
              Swal.fire({
                icon: 'warning',
                text: `The value of Months remains ${this.param.months}, Do you want to continue? `,
                showCancelButton: true,
                confirmButtonText: 'Yes'
              }).then((result) => {
                if (result.value) {
                obj.months=this.param.months;
                obj.policy=this.param.policies;
                // obj.maxHistoricalWell=this.param.maxHistoricalWell;
                this.loadingOverlayService.show();
                this.companiesService.update(this.param.id, obj, () => {
                  this.loading = false;
                  this.submitted = false;
                  
                }).subscribe((res) => {
                  this.companiesService.UpdatePolicyInWell(this.companyId,obj.months).subscribe(
                    (res) => {  
                      this.success.emit();
                      this.loadingOverlayService.hide();
                    },(err) => {
                      this.loadingOverlayService.hide()
                    });
                
                });
                }
                this.loading = false;
                this.submitted = false;
              });
            }
            
          }
        }
      } else {
        if(str=='update'){
          this.cancel.emit();
        }
      }
    }
  }
  onCancel() {
    this.cancel.emit();
  }

  onPolicyselect(e){
    this.getWellWithCompanyId(this.companyId);
    this.policies.setValue(e);
    let maxHistoricalWell=this.maxHistoricalWell.value;
    const months = this.months.value;
    if (e === "Count") {
      this.months.setValidators([]);
      this.maxHistoricalWell.setValidators([Validators.required, Validators.min(0), Validators.max(1000)]);
    } else {
      this.months.setValidators([Validators.min(1), Validators.max(60),Validators.required]);
      this.maxHistoricalWell.setValidators([Validators.min(0), Validators.max(1000)]);
      maxHistoricalWell = 0;
      this.isAllWell.setValue(false);
    }
    this.months.reset();
    this.months.setValue(months);
    this.maxHistoricalWell.reset();
    this.maxHistoricalWell.setValue(maxHistoricalWell);
  }
applyPolicy(){
    this.IsAgePolicyApply=true;
    if(this.param){ 
   this.onSubmit(this.form.value,'Apply'); 
    }
  }
  
  onChange(e) {
    this.type.setValue(e);
    const maxFracSpread = this.maxFracSpread.value;
    const maxEquipment = this.maxEquipment.value;
    if (e === 0) {
      this.maxFracSpread.setValidators([]);
      this.maxEquipment.setValidators([]);
    } else {
      this.maxFracSpread.setValidators([Validators.min(0), Validators.max(1000)]);
      this.maxEquipment.setValidators([Validators.min(0), Validators.max(1000)]);
    }
    this.maxFracSpread.reset();
    this.maxEquipment.reset();
    this.maxFracSpread.setValue(maxFracSpread);
    this.maxEquipment.setValue(maxEquipment);
  }

  getWells(e) {
    setTimeout(() => {
      this.dataWells = e;
    });
  }

  getEquipment(e) {
    this.dataEquipment = e;
  }

  getSpread(e) {
    this.dataSpread = e;
  }

  getCompanyItem(id: number,str) {
    this.loadingOverlayService.show();
    this.companiesService.getCompanyId(id).subscribe(
      (res) => {
        // sort by id Wells desc
        const dataWells = orderBy(res.result.wellDtos, ['id'], ['desc']);
        this.dataWells = dataWells;
        this.originDataWells = cloneDeep(this.dataWells);
        // sort by id FracSpreads desc
        const dataFracSpreads = orderBy(res.result.fracSpreadDtos, ['id'], ['desc']);
        this.dataSpread = dataFracSpreads;
        this.originDataSpread = cloneDeep(this.dataSpread);
        // sort by id Equipment desc
        const dataEquipment = orderBy(res.result.equipmentDtos, ['id'], ['desc']);
        this.dataEquipment = dataEquipment;
        this.originDataEquipment = cloneDeep(this.dataEquipment);
     
          this.loadingOverlayService.hide();
          if(str=='Apply'){
            this.toastr.success('Company policy is updated', 'Success', {
              timeOut: 2000
            });
          }
          else if(str=='update'){
            this.success.emit();
          }
          
      }
    );
  }

  getIsCheckAll(e) {
    this.isAllWell.setValue(e);
    // Set Validator maxHistoricalWell
    let maxHistoricalWell = this.maxHistoricalWell.value;
    if (e) {
      this.maxHistoricalWell.setValidators([Validators.min(0), Validators.max(1000)]);
      maxHistoricalWell = '';
    } else {
      this.maxHistoricalWell.setValidators([Validators.required, Validators.min(0), Validators.max(1000)]);
      if (maxHistoricalWell === 'All') {
        maxHistoricalWell = 0;
      }
    }
    this.maxHistoricalWell.reset();

    this.maxHistoricalWell.setValue(maxHistoricalWell);
  }

  isChangeOriginData() {
    return !isEqual(this.originFormValue, this.form.value) || !isEqual(this.originDataWells, this.dataWells)
    || !isEqual(this.originDataSpread, this.dataSpread) || !isEqual(this.originDataEquipment, this.dataEquipment);
  }
ischangeMonthsValue(){
  if (this.originFormValue && this.originFormValue.policies=='Age' && this.originFormValue.policies==this.policies.value &&  this.originFormValue.months==this.months.value){
return false;
}
else{
  return true;
}
}
}